import { useQuery } from 'react-query';

import type { FailedDocumentDto } from '../../../../backend/src/case/run/dto/get-failed-docs.response.dto';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetFailedDocs = (runId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<FailedDocumentDto[]>(
    [QueryEntity.FailedDocs, runId],
    () => {
      return fetch(`${APIBaseChronos}/api/run/${runId}/failed-docs`, fetchConfigGET).then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      });
    },
    {
      enabled: !!runId,
      refetchOnWindowFocus: false,
    },
  );
};
